const CALLBACK_NAME = '__googleMapsApiOnLoadCallback'
const OPTIONS_KEYS = ['channel', 'client', 'key', 'language', 'region', 'v']

export const LoadGoogleMapsApi = {
  get: options => {
    options = options || {}

    return new Promise<any>((resolve, reject) => {
      // Evita volver a incluir el script de maps.googleapis.com cuando cargamos mas de un mapa en la misma sesion
      if ('google' in window && 'maps' in google) {
        resolve(google.maps)
      } else {
        var timeoutId = setTimeout(function() {
          window[CALLBACK_NAME] = () => {
            return
          }

          reject(new Error('Could not load the Google Maps API'))
        }, options.timeout || 10000)

        window[CALLBACK_NAME] = function() {
          if (timeoutId !== null) {
            clearTimeout(timeoutId)
          }

          resolve(google.maps)
          delete window[CALLBACK_NAME]
        }

        const scriptElement = document.createElement('script')
        const params = ['callback=' + CALLBACK_NAME]

        OPTIONS_KEYS.forEach(function(key) {
          if (options[key]) {
            params.push(key + '=' + options[key])
          }
        })

        if (options.libraries && options.libraries.length) {
          params.push('libraries=' + options.libraries.join(','))
        }
        scriptElement.src = 'https://maps.googleapis.com/maps/api/js?' + params.join('&')

        document.body.appendChild(scriptElement)
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/utils/loadGoogleMapsApi.ts